__turbopack_context__.v({
  "className": "ivyprestoheadline_a3e33cb4-module__G4bXqW__className",
  "variable": "ivyprestoheadline_a3e33cb4-module__G4bXqW__variable",
});
